// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-group[data-v-561a2d9a]{height:35px}button[data-v-561a2d9a]{font-size:.76562rem!important;padding:4px 7px}.btn-outline-primary[data-v-561a2d9a]{background-color:#fff}.btn-outline-primary[data-v-561a2d9a]:hover{background-color:#4d92e3}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
